import {
  CampaignFilterModel,
  CampaignStatusFilter,
  useCampaignFilter,
  useSetCampaignFilter,
} from '@gripp/shared-logic';
import { FilterChip, FilterSectionTitle, tokens } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';

const STATUSES: CampaignStatusFilter[] = ['DRAFT', 'SCHEDULED', 'SENT'];

export const CampaignsFilterPanel = () => {
  const { t } = useTranslation();
  const { data: filter } = useCampaignFilter();
  const { mutateAsync: setFilter } = useSetCampaignFilter();

  const onSelect = async (status: CampaignStatusFilter | undefined) => {
    if (!filter) return;
    const next = new CampaignFilterModel({
      ...filter,
      status:
        status === undefined || filter.status === status ? undefined : status,
    });
    await setFilter(next);
  };

  const isAllSelected = filter?.status === undefined;

  return (
    <View style={styles.container}>
      <View style={styles.section}>
        <FilterSectionTitle>
          {t('campaigns.filter.status', 'Status')}
        </FilterSectionTitle>
        <View style={styles.optionsContainer}>
          <FilterChip
            label={t('campaigns.filter.all', 'All')}
            selected={isAllSelected}
            onPress={() => onSelect(undefined)}
            testID="campaign-filter-status-all"
          />
          {STATUSES.map((s) => {
            const isSelected = filter?.status === s;
            const label = t(
              `campaigns.status.${s.toLowerCase()}`,
              s.charAt(0) + s.slice(1).toLowerCase()
            );
            return (
              <FilterChip
                key={s}
                label={label}
                selected={isSelected}
                onPress={() => onSelect(s)}
                testID={`campaign-filter-status-${s.toLowerCase()}`}
              />
            );
          })}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: tokens.spacing.lg,
  },
  section: {
    paddingTop: tokens.spacing['2xl'],
  },
  optionsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: tokens.spacing.sm,
  },
});
